import React from 'react';
import './style/index.scss';
export class LoadingIndicator extends React.Component {
    render() {
        return (React.createElement("div", { className: `loading-indicator ${this.props.className}` },
            React.createElement("svg", { className: "loading-indicator__circle", viewBox: "25 25 50 50" },
                React.createElement("circle", { className: "loading-indicator__circle-path", cx: "50", cy: "50", r: "20", fill: "none", strokeWidth: "2", strokeMiterlimit: "10" }))));
    }
}
export default { LoadingIndicator };
